import {
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING,
  CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED,
  CAMPAIGN_APPROVAL_PANEL_EMPTY,
  CAMPAIGN_APPROVAL_PANEL_TITLE,
} from "../../../../i18n/keysTranslations";

const MULTI_PANEL_COPY_BY_STATUS = {
  pending: {
    title: CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING,
    empty: CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING,
  },
  approved: {
    title: CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED,
    empty: CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED,
  },
  rejected: {
    title: CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED,
    empty: CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED,
  },
};

export const getCampaignApprovalPanelCopy = ({
  isMultiReviewer,
  globalStatus,
  copyType,
}) => {
  if (!isMultiReviewer) {
    return copyType === "title"
      ? CAMPAIGN_APPROVAL_PANEL_TITLE
      : CAMPAIGN_APPROVAL_PANEL_EMPTY;
  }

  const copyByStatus =
    MULTI_PANEL_COPY_BY_STATUS[globalStatus] ||
    MULTI_PANEL_COPY_BY_STATUS.pending;

  return copyByStatus[copyType];
};
